<template>
  <div>
    <loading-view v-if="loading" />
    <h1 class="bd-title pageTitle" id="content">
      Quote
      <small v-if="quote">{{ quote.label }}</small>
    </h1>
    <div class="form">
      <quote-form 
        v-on="$listeners"
        v-bind:request="quote"
        v-bind:response="quote_response"
        v-on:submit="onSubmit"
        v-bind:loading="loading"
      />
    </div>
  </div>
</template>

<script>
import QuoteForm from '@/components/rfqs/Form';
import LoadingView from '@/components/common/LoadingView';
import { datadogLogs } from '@datadog/browser-logs';
import { getInstance } from '../../auth';

const PortalApi = require("@brightoncromwell/portal-api");
const quotesApiInstance = new PortalApi.QuotesApi();
let defaultClient = PortalApi.ApiClient.instance;

export default {
  name: "quote",
  metaInfo: {
    title: "QuoteEdit"
  },
  components: {
    'quote-form': QuoteForm,
    "loading-view": LoadingView
  },
  data() {
    return {
      quote: null,
      quote_response: null,
      loading: false
    };
  },
  methods: {
    createResponse: function(quotes) {
      let response = {
        fob: quotes.fob || '',
        ref_no: quotes.ref_no,
        expiration_ts: quotes.expiration_ts,
        comments: quotes.comments,
        order_minimum_cost: quotes.order_minimum_cost,
        line_minimum_cost: quotes.line_minimum_cost,
        lines: [],
        additional_costs: []
      };

      quotes.additional_costs.forEach((additional_cost) => {
        let response_additional_cost = {
          amount: additional_cost.amount,
          label: additional_cost.label,
          per_unit: additional_cost.per_unit
        };
        response.additional_costs.push(response_additional_cost);
      });

      quotes.lines.forEach((quote_line) => {
        let response_line = {
          id: quote_line.id,
          nsn: quote_line.nsn,
          description: quote_line.description,
          part_number: quote_line.part_number,
          no_quote_classification: quote_line.no_quote_classification || null,
          no_quote_other_reason: quote_line.no_quote_other_reason || null,
          coo: quote_line.coo || '',
          weight_per_uom: quote_line.weight_per_uom,
          minimum_order_quantity: quote_line.minimum_order_quantity,
          will_advise_dt: quote_line.will_advise_dt,
          quantities: [],
          additional_costs: [],
          disposition: '',
          alternate_nsn: { name: null, is_form_fit_function_match: null, description: null },
          alternate_part_number: { name: null, is_form_fit_function_match: null, description: null }
        };

        quote_line.quantities.forEach((quote_line_quantity) => {
          let response_line_quantity = {
            qty: quote_line_quantity.qty,
            uom: quote_line_quantity.uom,
            lead_time: quote_line_quantity.lead_time,
            cost: quote_line_quantity.cost,
            condition: quote_line_quantity.condition,
            rfq_line_quantity_id: quote_line_quantity.rfq_line_quantity_id,
            no_quote: quote_line_quantity.no_quote
          };
          response_line.quantities.push(response_line_quantity);
        });

        quote_line.additional_costs.forEach((quote_line_addl_cost) => {
          let response_line_addl_cost = {
            amount: quote_line_addl_cost.amount,
            label: quote_line_addl_cost.label,
            per_unit: quote_line_addl_cost.per_unit
          };
          response_line.additional_costs.push(response_line_addl_cost);
        });



        response.lines.push(response_line);
      });
      return response;
    },
    getQuote: async function(id) {
      const token = await this.getToken();
      let BearerAuth = defaultClient.authentications['BearerAuth'];
      BearerAuth.accessToken = token;
      this.loading = true;
      quotesApiInstance.quotesIdGet(id, (error, data, response) => {
        this.loading = false;
        if (error) {
          console.error(error);
          datadogLogs.logger.error('getQuote() failed', { quoteId: id,  error: error });
          if(error == "login_required"){
                  window.location.href = "/signin";
          }
          this.$emit('onError', response, true)
        } else {
          this.quote = data;
          this.quote_response = this.createResponse(data);
          //console.log("here's the quote and quote_response");
          //console.log(this.quote.lines[0].additional_costs[0]);
          datadogLogs.logger.info('getQuote() succeeded', { label: this.quote.label });
        }
      });
    },
    postQuote: async function(id, quote_response) {
      const token = await this.getToken();
      let BearerAuth = defaultClient.authentications['BearerAuth'];
      BearerAuth.accessToken = token;
      this.loading = true;
      let opts = {
        quoteResponse: quote_response
      };
      quotesApiInstance.quotesIdPost(id, opts, (error, data, response) => {
        if (error) {
          datadogLogs.logger.error('postQuote() failed', { quoteId: id,  error: error });
          console.error(error);
          this.$emit('onError', response)
          this.loading = false;
        } else {
          datadogLogs.logger.info('postQuote() succeeded', { label: this.quote.label });
          this.$router.push("/quotes/" + response.text)
        }
      });
    },
    // $auth isn't loaded in by the time the page tries to get the token, so we need to do some extra steps in order to wait
    getToken: async function(){
      return new Promise((resolve, reject) => {
        const instance = getInstance();
        if(instance.loading == false){
          // Redirect if the user isn't authenticated
          if (!instance.isAuthenticated){
            window.location.href = "/signin";
          }
          resolve(instance.getTokenSilently());
        }
        else{
        instance.$watch("loading", loading => {
            if (loading == false && instance.isAuthenticated){
              instance.getTokenSilently().then(authToken => {resolve(authToken)}).catch(error => {
                if(error == "login_required"){
                  window.location.href = "/signin";
                }
                reject(error)});
            }
            // Redirect if the user isn't authenticated
            else if (!instance.isAuthenticated){
              window.location.href = "/signin";
            }
          });
        }
      });
    },
    onSubmit() {
      let id = this.quote.id;
      let quote_response = this.quote_response;
      datadogLogs.logger.info('Quote #' + this.quote.label + ' submitted', {});

      this.postQuote(id, quote_response);
    }
  },
  created() {
    let id = this.$route.params.id;
    this.getQuote(id);
  },
  mounted() {
     datadogLogs.logger.info('Quote editor displayed', {});
  }
};
</script>
